/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { ScrollDownButtonState, ScrollDownButtonSlots } from './ScrollDownButton.types';

/**
 * Render the final JSX of ScrollDownButton
 */
export const renderScrollDownButton_unstable = (state: ScrollDownButtonState): JSXElement => {
  assertSlots<ScrollDownButtonSlots>(state);

  return (
    <state.root>
      {state.spinner && (
        <state.spinner>
          <defs>
            <mask id={state.maskId}>
              {state.spinnerMaskStroke && <state.spinnerMaskStroke />}
              {state.spinnerMaskBackground && <state.spinnerMaskBackground />}
            </mask>
          </defs>

          <g mask={`url(#${state.maskId})`}>{state.spinnerBase && <state.spinnerBase />}</g>
        </state.spinner>
      )}
      {state.icon && <state.icon />}
    </state.root>
  );
};
